import CityPageTemplate from "../city-template/CityPageTemplate";
import { warrenConfig } from "./data";

export default function WarrenPage() {
  return <CityPageTemplate config={warrenConfig} />;
}